export const LANDOWNERS = {
    FETCH_LANDOWNERS: {
        MAIN: 'FETCH_LANDOWNERS',
        SUCCESS: 'FETCH_LANDOWNERS_SUCCESS',
        FAILURE: 'FETCH_LANDOWNERS_FAILURE'
    },
};
